// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "中国近现代史纲要",
      "tec": "黄玉兰",
      "week": "1-6,9-14周",
      "add": "教学楼B座124自控"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王建华",
      "week": "1-6,9-18周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "电路",
      "tec": "于佳申爱兵",
      "week": "1-6,9-18周",
      "add": "教学楼A座220电力"
    },
    {
      "sub": "工程制图与CAD",
      "tec": "孙振东",
      "week": "1-6,9-18周",
      "add": "教学楼A座116电力"
    },
    0
  ],
  "2": [
    {
      "sub": "电路",
      "tec": "于佳申爱兵",
      "week": "1-6,9-18周",
      "add": "教学楼A座221电力"
    },
    {
      "sub": "复变函数与积分变换",
      "tec": "李文婉",
      "week": "1-6,9-18周",
      "add": "教学楼A座222电力"
    },
    0,
    {
      "sub": "数字电子技术",
      "tec": "张玉梅",
      "week": "1-6,9-18周",
      "add": "教学楼A座226电力"
    },
    [
      {
        "sub": "形势与政策",
        "tec": "杨淑一",
        "week": "1-4周",
        "add": "教学楼C座306教务"
      },
      {
        "sub": "就业创业指导",
        "tec": "赵毅王刚王祎雪刘东岩",
        "week": "9-12周",
        "add": "大活礼堂"
      }
    ]
  ],
  "3": [
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-6,9-16周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "黄玉兰",
      "week": "1-6,9-14周",
      "add": "教学楼B座124自控"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电路",
      "tec": "于佳申爱兵",
      "week": "1-6,9-18周",
      "add": "教学楼A座322电力"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "轮滑",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女排",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "李罡",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "张凯",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女网",
        "tec": "朱永",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男羽",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "高佳",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    {
      "sub": "电路实验",
      "tec": "贺安东",
      "week": "1-6,9-14周",
      "add": "实训楼A座204"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "王建华",
      "week": "1-6,9-18双周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "于丹丹",
      "week": "1-6,9-18周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-6,9-16周",
      "add": "教学楼A座221电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
